import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";
import { format, addDays, addMonths, isSameMonth } from "date-fns";

import ReactEcharts from "echarts-for-react";

import * as Constant from "@app/Constant.js";

import { NurseryClassChild } from "../../components/NurseryClassChild";

import flyengStyle from "../../components/style";

import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart/index";
import CommonVerticalBarChart from "@app/components/CommonVerticalBarChart/index";

const ContentNursery = forwardRef(
    ({ statPeriod, libCategories, isRoleBranch, branchId, branchName, nurseryId, nurseryName, classId, className, updateViewSubOption, onViewSubOptionSelected, statAll, updateCategoryStat }, ref) => {
        const [stat, setStat] = useState(false);
        const [statClass, setStatClass] = useState(false);
        const [statOs, setStatOs] = useState(false);
        const [statContentSum, setStatContentSum] = useState(false);
        const [statChild, setStatChild] = useState(false);
        const [childStatDate, setChildStatDate] = useState(false);
        const [statChildStat, setStatChildStat] = useState(false);
        let colorContentSum = false;

        useImperativeHandle(ref, () => ({
            getExcelData(callback) {
                if (stat && stat.length > 0) {
                    const isClassTotal = classId == "-";
                    const excelData = {
                        fileName: `플라잉홈_${className ? "클래스" : "원"}통계`,
                        sheets: isClassTotal
                            ? [
                                  {
                                      name: "접속",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} 접속 통계`,
                                      columnTitle: ["반", "안드로이드", "IOS", "웹"],
                                      data: statClass ? statClass.map((s) => [s.name, s.osAndroid || 0, s.osIos || 0, s.osWeb || 0]) : [],
                                  },
                                  {
                                      name: "반별",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} 콘텐츠 통계`,
                                      columnTitle: ["반", "사용량"],
                                      data: statClass ? statClass.map((s) => [s.name, s.playCount]) : [],
                                  },
                                  {
                                      name: "콘텐츠",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} 콘텐츠 통계`,
                                      columnTitle: ["카테고리", "사용량"],
                                      data: statContentSum ? statContentSum.map((s) => [s.name, s.value]) : [],
                                  },
                                  {
                                      name: "가입",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} 가입 통계(원아 자료 기준일 - ${childStatDate})`,
                                      columnTitle: ["반", "계약 원아 수", "회원 가입 수"],
                                      data: statClass ? statClass.map((s) => [s.name, s.contractChild || 0, s.childJoin || 0]) : [],
                                  },
                              ]
                            : [
                                  {
                                      name: "접속",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} - ${className} 접속 통계`,
                                      columnTitle: ["", "안드로이드", "IOS", "웹"],
                                      data: stat ? stat.map((s) => [s.statDate, s.osAndroid || 0, s.osIos || 0, s.osWeb || 0]) : [],
                                  },
                                  {
                                      name: "콘텐츠",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} - ${className} 콘텐츠 통계`,
                                      columnTitle: [""].concat(libCategories ? libCategories.map((lc) => `${lc.name} 실행 수`) : []),
                                      data: stat ? stat.map((s) => [s.statDate].concat(libCategories ? libCategories.map((lc) => s[`playCountSumCat_${lc.id}`] || 0) : 0)) : [],
                                  },
                                  {
                                      name: "원아",
                                      title: `${isRoleBranch ? "" : branchName + " -"} ${nurseryName} - ${className} 원아별 사용량`,
                                      columnTitle: ["원아", "실행 수"],
                                      data: statChildStat ? statChildStat.map((s) => [s.name, s.playCount]) : [],
                                  },
                              ],
                    };
                    callback(null, excelData);
                }
            },
        }));

        const initState = () => {
            setStat(false);
            setStatOs(false);
            setStatContentSum(false);
            setChildStatDate(false);
            setStatChild(false);
            setStatChildStat(false);
        };

        const getStat = () => {
            initState();

            const isClassTotal = classId == "-";
            if (isClassTotal) {
                if (statAll) {
                    applyData(statAll);
                    return;
                } else {
                    updateCategoryStat(false);
                }
            }

            var url = isClassTotal
                ? `/api/flyeng_stat_2022/home/activity/branch/${branchId}/nursery/${nurseryId}`
                : `/api/flyeng_stat_2022/home/activity/branch/${branchId}/nursery/${nurseryId}/class/${classId}`;
            axios({
                method: "POST",
                url: Constant.API_DOMAIN + url,
                data: {
                    start: statPeriod.startDate,
                    end: statPeriod.endDate,
                    periodType: statPeriod.type,
                },
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        var data = result.data;
                        if (isClassTotal) {
                            updateCategoryStat(data);
                        } else {
                            applyData(data);
                        }
                    } else {
                        alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        };

        const applyData = (data) => {
            if (!data) {
                initState();
                return;
            }
            const isClassTotal = classId == "-";
            var classes = data.classes;
            var childStat = data.childStat;

            var stat = [];
            var statOs = [
                { id: "android", name: "안드로이드", value: 0 },
                { id: "ios", name: "IOS", value: 0 },
                { id: "web", name: "웹", value: 0 },
            ];
            var statContentSum = libCategories.map((lc) => {
                return { id: `playCountSumCat_${lc.id}`, name: lc.name, value: 0 };
            });
            var statChild = { contractChild: 0, childJoin: 0 };
            if (classes) {
                classes.forEach((c) => {
                    c.playCount = 0;
                    c.osAndroid = 0;
                    c.osIos = 0;
                    c.osWeb = 0;
                    statChild.contractChild += c.contractChild ? c.contractChild : 0;
                    statChild.childJoin += c.childJoin ? c.childJoin : 0;
                });
            }

            let start = new Date(statPeriod.startDate);
            let day = new Date(statPeriod.startDate);
            for (let i = 0; i < 99; i++) {
                const statDate = format(day, statPeriod.type === "year" ? "yyyy-MM" : "yyyy-MM-dd");
                const statDateStr = format(day, statPeriod.type === "year" ? "yyyy-MM" : "MM-dd");
                const statDateList = data.data.filter((s) => s.statDate === statDate);
                let statDay = { statDate: statDateStr, playCount: 0 };

                statDateList.forEach((s) => {
                    if (isClassTotal) {
                        var sClass = classes ? classes.find((c) => c.id == s.id) : null;
                        if (sClass) {
                            if (libCategories) {
                                libCategories.forEach((lc) => {
                                    const fieldId = `playCountSumCat_${lc.id}`;
                                    sClass.playCount += s[fieldId] || 0;
                                });
                            }
                            sClass.osAndroid += s.osAndroid || 0;
                            sClass.osIos += s.osIos || 0;
                            sClass.osWeb += s.osWeb || 0;
                            s.name = sClass.name;
                        }
                    } else {
                        statDay.osAndroid = s.osAndroid || 0;
                        statDay.osIos = s.osIos || 0;
                        statDay.osWeb = s.osWeb || 0;
                    }

                    statOs[0].value += s.osAndroid ? s.osAndroid : 0;
                    statOs[1].value += s.osIos ? s.osIos : 0;
                    statOs[2].value += s.osWeb ? s.osWeb : 0;
                    if (libCategories) {
                        libCategories.forEach((lc) => {
                            const fieldId = `playCountSumCat_${lc.id}`;
                            statDay.playCount += s[fieldId] || 0;
                        });
                    }
                });
                stat.push(statDay);

                if (statPeriod.type === "week") {
                    day = addDays(day, 1);
                    if (i >= 6) break;
                } else if (statPeriod.type === "month") {
                    day = addDays(day, 1);
                    if (!isSameMonth(day, start)) break;
                } else {
                    // year
                    day = addMonths(day, 1);
                    if (i > 11) break;
                }
            }
            statContentSum.forEach((s) => {
                s.value = data.data.reduce((ac, current) => ac + (current[s.id] || 0), 0);
            });
            setStat(stat);
            setStatClass(classes);
            setStatOs(statOs);
            setStatContentSum(statContentSum);
            setChildStatDate(data.childStatDate);
            setStatChild(statChild);
            setStatChildStat(childStat);

            if (isClassTotal && updateViewSubOption) {
                updateViewSubOption([{ name: "전체", id: "-" }].concat(classes), "-");
            }
        };

        useEffect(() => {
            getStat();
            return () => {};
        }, [statPeriod, classId]);

        useEffect(() => {
            applyData(statAll);
            return () => {};
        }, [statAll]);

        const onClassSelect = (e) => {
            if (onViewSubOptionSelected) {
                onViewSubOptionSelected(e.id);
            }
        };
        const onContentSumEvent = {
            finished: (e, charts) => {
                if (!colorContentSum) {
                    colorContentSum = charts._model.option.color;
                } else {
                    if (colorContentSum.length != charts._model.option.color.length) {
                        colorContentSum = charts._model.option.color;
                    } else {
                        let changed = false;
                        for (let i = 0; i < colorContentSum.length; i++) {
                            if (colorContentSum[i] != charts._model.option.color[i]) {
                                changed = true;
                                break;
                            }
                        }
                        if (changed) {
                            colorContentSum = charts._model.option.color;
                        }
                    }
                }
            },
        };
        if (!stat) {
            return (
                <div className="w-100">
                    <div className="row">
                        <div
                            className="col"
                            style={{
                                height: "500px",
                                textAlign: "center",
                                paddingTop: `100px`,
                            }}
                        >
                            <span className="dashboard-spinner spinner-xxl"></span>
                        </div>
                    </div>
                </div>
            );
        } else {
            const optionOs = {
                tooltip: {
                    trigger: "item",
                    formatter: (param) => {
                        return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)" : "";
                    },
                },
                series: {
                    type: "pie",
                    center: ["50%", "55%"],
                    data: statOs,
                    radius: "80%",
                    startAngle: 180,
                    label: {
                        show: true,
                        formatter: function (params) {
                            return `${params.name}\n${params.value.toLocaleString()}, ${params.percent}%`;
                        },
                        fontSize: 15,
                        color: "#000",
                    },
                },
                color: ["#60d7c5", "#3861a5", "#b9ed4a"],
            };
            const optionContentSum = {
                tooltip: {
                    trigger: "item",
                    backgroundColor: "rgba(50,50,50,0.9)",
                    formatter: (params, chart, test) => {
                        const total = statContentSum ? statContentSum.reduce((ac, current) => ac + current.value, 0) : 0;
                        const tip = statContentSum
                            ? statContentSum
                                  .map(
                                      (s, idx) =>
                                          `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 200px'>${
                                              colorContentSum && colorContentSum.length > idx
                                                  ? `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${colorContentSum[idx]};"></span>`
                                                  : ""
                                          }${s.name}: ${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div>`
                                  )
                                  .join("")
                            : "";
                        return tip + `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold m-1' style='width: 200px'>합계: ${total.toLocaleString()}</div>`;
                    },
                },
                series: [
                    {
                        type: "pie",
                        data: statContentSum,
                        radius: ["0%", "95%"],
                        labelLine: {
                            show: false,
                        },
                        label: {
                            show: false,
                            position: "center",
                        },
                    },
                ],
                color: flyengStyle.seriesHomeColor.normal,
            };
            const isClassTotal = classId == "-";
            const classTotalChartOption = {
                tooltipFormatter: (params, chart, test) => {
                    return params && params.length > 0 ? `${params[0].axisValue} 사용량<br />${params[0].marker} 전체: ${params[0].value ? params[0].value.toLocaleString() : 0}` : "";
                },
                xAxis: {
                    name: "건",
                    series: flyengStyle.seriesHomePlayChart2022,
                },
                stacks: [{ stack: "base", showSum: false, showSumTooltip: false, showPercent: false }],
                yAxis: { field: "name" },
                showSum: false,
                sort: false,
                showLegend: false,
                grid: {
                    top: "10%",
                    left: "10%",
                    bottom: "10%",
                },
                legend: {
                    x: "right",
                },
            };
            const classChartOption = {
                tooltipFormatter: (params, chart, test) => {
                    return params && params.length > 0 ? `${className} ${params[0].axisValue} 실행 수<br />${params[0].marker} 전체: ${params[0].value ? params[0].value.toLocaleString() : 0}` : "";
                },
                xAxis: { field: "statDate" },
                yAxis: {
                    name: "사용량(건)",
                    series: flyengStyle.seriesHomePlayChart2022,
                },
                stacks: [{ stack: "base", showSum: false, showSumTooltip: false, showPercent: false }],
                showLegend: false,
                grid: {
                    top: "10%",
                    left: "10%",
                    bottom: "10%",
                },
            };
            const childJoinChartOption = {
                xAxis: {
                    type: "category",
                    data: ["가입 현황"],
                },
                yAxis: {
                    name: "명",
                    type: "value",
                },
                grid: {
                    top: "20%",
                    left: "10%",
                    bottom: "10%",
                },
                legend: {
                    x: "right",
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        crossStyle: {
                            color: "#999",
                        },
                    },
                },
                series: [
                    {
                        type: "bar",
                        data: [statChild ? statChild.contractChild : 0],
                        ...flyengStyle.seriesHomeChildChart[0],
                    },
                    {
                        type: "bar",
                        data: [statChild ? statChild.childJoin : 0],
                        ...flyengStyle.seriesHomeChildChart[1],
                    },
                ],
            };
            const childStatChartOption = {
                tooltipFormatter: (params, chart, test) => {
                    return params && params.length > 0 ? `${params[0].axisValue} 실행 수<br />${params[0].marker} 전체: ${params[0].value ? params[0].value.toLocaleString() : 0}` : "";
                },
                xAxis: {
                    name: "건",
                    series: flyengStyle.seriesHomePlayChartChild,
                },
                stacks: [{ stack: "base", showSum: false, showSumTooltip: false, showPercent: false }],
                yAxis: { field: "name" },
                showSum: true,
                sort: false,
                showLegend: false,
                grid: {
                    top: "0%",
                    left: "10%",
                    bottom: "10%",
                },
                legend: {
                    x: "right",
                },
            };
            return (
                <div className="w-100">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="card">
                                <div className={`card-header stat-content-card-title`}>접속 경로</div>
                                <div className="card-body" style={{ height: "auto" }}>
                                    <div>
                                        <ReactEcharts theme="macarons" option={optionOs} style={{ height: `200px` }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="card">
                                <div className={`card-header stat-content-card-title`}>콘텐츠 사용량</div>
                                <div className="card-body" style={{ height: "auto" }}>
                                    <div>
                                        <ReactEcharts theme="macarons" option={optionContentSum} style={{ height: `200px` }} onEvents={onContentSumEvent} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {isClassTotal && (
                        <>
                            <div className="row">
                                <div className="col">
                                    <div
                                        className="card"
                                        style={{
                                            height: statClass && statClass.length > 0 ? statClass.length * 30 + 200 : 200,
                                        }}
                                    >
                                        <div className={`card-header stat-content-card-title`}>반별 사용량</div>
                                        <div className="card-body">
                                            {/* <ContentNurseryChart type="-" statList={stat} onClassSelect={onViewSubOptionSelected} /> */}
                                            <CommonVerticalBarChart chartData={statClass} chartOption={classTotalChartOption} onSelect={onClassSelect.bind(this)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className={`card-header stat-content-card-title`}>가입 현황</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                                                    <div className="">
                                                        <NurseryClassChild height={220} statList={statClass} childStatDate={childStatDate} />
                                                    </div>
                                                </div>
                                                <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                                                    <div className="">
                                                        <ReactEcharts theme="macarons" style={{ height: "370px" }} option={childJoinChartOption} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {!isClassTotal && (
                        <>
                            <div className="row">
                                <div className="col">
                                    <div className="card" style={{ height: "400px" }}>
                                        <div className={`card-header stat-content-card-title`}>기간별 사용량</div>
                                        <div className="card-body">
                                            <CommonHorizontalBarChart chartData={stat} chartOption={classChartOption} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="card" style={{ height: `${210 + (statChildStat ? statChildStat.length * 40 : 0)}px` }}>
                                        <div className={`card-header stat-content-card-title`}>원아별 사용량</div>
                                        <div className="card-body">
                                            <CommonVerticalBarChart chartData={statChildStat} chartOption={childStatChartOption} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            );
        }
    }
);

export default ContentNursery;
